const COLORS = {
  PLOTS: {
    red: "#F7D5D2",
    orange: "#F9E2CC",
    blue: "#CCE1EB",
    green: "#D7E7CE",
  },
  POINTS: {
    // Remove later when new color is tested and approved
    // red: "#D52B1E",
    red: "#CD0000",
    // Remove later when new color is tested and approved
    // orange: "#E17000",
    orange: "#FF9900",
    blue: "#01689B",
    green: "#39870C",
  },
  LINES: {
    // Remove later when new color is tested and approved
    // red: "#D52B1E",
    red: "#CD0000",
    // Remove later when new color is tested and approved
    // orange: "#E17000",
    orange: "#FF9900",
    blue: "#01689B",
    green: "#39870C",
  },
} as const;

export default COLORS;
